console.log('Application loading.');

import * as Sentry from "@sentry/browser";

// any CSS you require will output into a single css file (app.css in this case)
require('../css/app.scss');

const $ = require('jquery');
const timeago = require("timeago.js");

require ('jquery.growl/stylesheets/jquery.growl.css');
const growl = require ('jquery.growl');

global.$ = $;
global.jQuery = $;
global.timeago = timeago;
global.growl = growl;

// this "modifies" the jquery module: adding behavior to it
// the bootstrap module doesn't export/return anything
require('bootstrap');

// or you can include specific pieces
// require('bootstrap/js/dist/tooltip');
// require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/tab');

$(document).ready(function() {

    if ($('body').data('sentryDsn')) {
        const options = {
            dsn: $('body').data('sentryDsn'),
            release: $('body').data('sentryRelease'),
            environment: $('body').data('sentryEnvironment'),
            integrations: [Sentry.browserTracingIntegration()],
            tracesSampleRate: 1.0,
        }
        console.log('[Sentry] Starting', options);
        Sentry.init(options);

        if ($('body').data('userId')) {
            const user = {
                id: $('body').data('userId'),
                name: $('body').data('userName'),
                email: $('body').data('userEmail')
            };
            console.log('[Sentry] Setting user', user);
            Sentry.setUser(user);
        }
    }

    $('[data-toggle="popover"]').popover();

    $('.custom-range').on("input change", function(el) {

        var span;
        var value = $(this).val();

        if (!$(this).siblings('span.range-target').data('disabled-text')) {
            $(this).siblings('span.range-target').data('disabled-text', $(this).siblings('span.range-target').html());
        }

        if (Number(value) == 0) {
            span = $(this).siblings('span.range-target').data('disabled-text') || '0 (disabled)';
        } else {
            span = value + ' seconds';
        }

        $(this).siblings('span.range-target').html(span);
    });
    $('.custom-range').trigger('input');


    $('img[data-player-preview]').each((i, e) => {
        var imgUrl = $(e).attr('src');

        var refreshInterval = setInterval(function() {
            var src = imgUrl + '?rand=' + Date.now();
            $(e).attr('src', src);
        }, 30000);

        $(e).on('error', function () {

            if ($(e).data('errorReportUrl')) {
                $.post($(e).data('errorReportUrl'));
            }

            clearInterval(refreshInterval);
            $(this).off('error');
            $(this).attr("src", require('../images/static-noise.jpg'));
        });
    });

    statusCheck();

    console.log('Application loaded.');

});

function statusCheck() {
    $('[data-player-online-check]').each((i, e) => {

        $(e).html('<i class="fa fa-cog fa-spin"></i> ' + $(e).html());

        $.getJSON($(e).data('player-online-check'), function(status) {
            if (status) {
                if (status.online) {
                    $(e).html('<i class="fa fa-circle text-success"></i> Online');
                } else {
                    $(e).html('<i class="fa fa-circle text-danger"></i> Offline');
                }
            } else {
                $(e).html('<i class="fa fa-circle text-gray"></i> Unknown');
            }

        })
        .fail(function() {
            $(e).html('<i class="fa fa-exclamation-triangle"></i> Unable to check status');
        });
    });
}

(function() {
    'use strict';
    window.addEventListener('load', function() {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function(form) {
            form.addEventListener('submit', function(event) {
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();


// https://symfony.com/doc/current/form/form_collections.html
// https://github.com/itools/symfony-collection

'use strict'

const itools_lib = {}

itools_lib.sfCollection = (() => {
    const init = (config = {}) => {
        if (!('content' in document.createElement('template'))) {
            console.error('HTML template will not working...')
            return
        }

        const {
            collectionsSelector = 'form div[data-prototype]',
            manageRemoveEntry = true,
            lang = {
                add: 'Add',
                remove: 'Remove'
            }
        } = config

        const collectionsElt = document.querySelectorAll(collectionsSelector)
        if (!collectionsElt.length) {
            return
        }


        collectionsElt.forEach((collectionElt, index) => {
            processCollectionElt(collectionElt, manageRemoveEntry, lang, index)
        })
    }

    const processCollectionElt = (
        collectionElt,
        manageRemoveEntry = false,
        lang,
        index
    ) => {
        collectionElt.setAttribute(
            'data-entry-index',
            collectionElt.children.length
        )

        appendEntryAddLink(collectionElt, lang)

        if (manageRemoveEntry) {
            appendEntryRemoveLink(collectionElt, lang)
        }

        collectionElt.addEventListener('click', evt =>
            configureCollectionElt(evt, manageRemoveEntry, lang)
        )
    }

    const appendEntryAddLink = (collectionElt, lang) => {
        // Allow custom label
        const entryLabel = collectionElt.getAttribute('data-entry-add-label') || '',
            entryLabelClass =
                collectionElt.getAttribute('data-entry-add-class') ||
                'btn btn-primary mt-2'

        const entryAddLink = getButtonElt(
            `${lang.add} ${entryLabel}`,
            'add',
            `${entryLabelClass}`
        )
        collectionElt.appendChild(entryAddLink)
    }

    const appendEntryRemoveLink = (collectionElt, lang) => {
        const entryLabel =
            collectionElt.getAttribute('data-entry-remove-label') || '',
            entryLabelClass =
                collectionElt.getAttribute('data-entry-remove-class') ||
                'btn btn-link btn-sm'

        const entryRemoveLink = getButtonElt(
            `${lang.remove} ${entryLabel}`,
            'remove',
            `${entryLabelClass}`
        )

        const collectionChildren = [...collectionElt.children]
            .filter(entryElt => !entryElt.hasAttribute('data-entry-action'))
            .forEach((entryElt, index) => {
                if (index > 0) {
                    entryElt.appendChild(entryRemoveLink.cloneNode(true))
                }
            })
    }

    const configureCollectionElt = (evt, manageRemoveEntry, lang) => {
        if (!evt.target.hasAttribute('data-entry-action')) {
            return
        }

        switch (evt.target.getAttribute('data-entry-action')) {
            case 'add':
                addEntry(evt.currentTarget, evt.target, manageRemoveEntry, lang)
                break
            case 'remove':
                removeEntry(evt.currentTarget, evt.target)
                break
        }
    }

    const addEntry = (collectionElt, entryAddButton, manageRemoveEntry, lang) => {
        // Get & update entryIndex
        const entryIndex = collectionElt.getAttribute('data-entry-index')


        if (+collectionElt.dataset.maxEntries <= entryIndex) {
            $.growl.error({message: 'You have reached the maximum number of ' + collectionElt.dataset.maxEntries +' entries.'});
            return;
        }

        collectionElt.setAttribute('data-entry-index', +entryIndex + 1)

        const entryPrototype = collectionElt.getAttribute('data-prototype'),
            templateContent = getTemplateContent(entryPrototype, entryIndex)

        // Add remove button, if necessary, before insert to the DOM
        if (manageRemoveEntry) {
            const entryLabel =
                collectionElt.getAttribute('data-entry-remove-label') || '',
                entryLabelClass =
                    collectionElt.getAttribute('data-entry-remove-class') ||
                    'btn btn-link btn-sm',
                entryRemoveLink = getButtonElt(
                    `${lang.remove} ${entryLabel}`,
                    'remove',
                    `${entryLabelClass}`
                )
            templateContent.firstChild.appendChild(entryRemoveLink)
        }

        entryAddButton.parentElement.insertBefore(templateContent, entryAddButton)
    }

    const removeEntry = (collectionElt, entryRemoveButton) => {
        const entryIndex = collectionElt.getAttribute('data-entry-index')
        collectionElt.setAttribute('data-entry-index', +entryIndex - 1)
        entryRemoveButton.parentElement.remove()
    }

    /**
     * HELPERS
     */

    const getButtonElt = (label, action, className = 'btn') => {
        const button = document.createElement('button')

        button.type = 'button'
        button.textContent = label
        button.className = className
        button.dataset.entryAction = action

        return button
    }

    const getTemplateContent = (entryPrototype, entryIndex) => {
        const template = document.createElement('template')

        const entryHtml = entryPrototype
            .replace(/__name__label__/g, `!New! ${entryIndex}`)
            .replace(/__name__/g, entryIndex)

        template.innerHTML = entryHtml.trim()

        return template.content
    }

    return {
        init
    }
})()

itools_lib.sfCollection.init({
    collectionsSelector: 'form div[data-prototype]',
    manageRemoveEntry: true,
    lang: {
        add: 'Add more information',
        remove: 'Remove'
    }
})
